"use client";
import { I18nUtil } from "@utils/i18n";
import { Icon, ospThemes } from "@ospweb/sdk-ui";
import Translations from "@translate/components/TokenDetails/ViewMoreButton";
import { cn } from "utils";
import { memo } from "react";

const I18n = I18nUtil.createScoped(Translations);

interface ViewMoreButtonProps {
  /** 按钮文本 */
  label?: string;
  /** 图标名称 */
  iconName?: string;
  /** 图标大小 */
  iconSize?: number;
  /** 图标颜色 */
  iconColor?: string;
  /** 容器自定义类名 */
  className?: string;
  /** 文本自定义类名 */
  labelClassName?: string;
  /** 点击事件处理函数 */
  onClick?: () => void;
}

/**
 * 查看更多按钮内容组件
 */
const ViewMoreButton = memo(
  ({
    label = I18n.t("View More"),
    iconName = "chevron-down",
    iconSize = 16,
    iconColor = ospThemes.colors.content_accent4_primary,
    className,
    labelClassName,
    onClick,
  }: ViewMoreButtonProps) => {
    return (
      <span
        data-openreplay-label="market_viewmorebutton_open"
        className={cn("inline-flex items-center", className)}
        onClick={onClick}
        role={onClick ? "button" : undefined}
        tabIndex={onClick ? 0 : undefined}
      >
        <Icon
          name={iconName}
          size={iconSize}
          color={iconColor}
          className="mr-1"
        />
        <span
          className={cn(
            "button_s text-content_accent4_primary whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px] hover:text-content_accent4_primary",
            labelClassName,
          )}
        >
          {label}
        </span>
      </span>
    );
  },
);

ViewMoreButton.displayName = "ViewMoreButton";

export { ViewMoreButton };
